import {AboutDecorationData, Product, ProductData} from "@/entities/product";
import {getSections} from "../lib/getSections";
import {useAccordion} from "../model/useAccordion";
import {ProductInformationItem} from "./ProductInformationItem";
import styles from "./ProductInformation.module.scss";

type Props = {
    product: Product,
    productDataCurrent: ProductData,
    aboutDecorationData: AboutDecorationData[];
    previewLength: number;
}

export const ProductInformation = ({product, productDataCurrent, aboutDecorationData, previewLength}: Props) => {
    const sections = getSections({
        product,
        productDataCurrent,
        aboutDecorationData,
        previewLength,
    });

    const {openedSection, toggleSection} = useAccordion(sections);

    return (
        <div className={styles.container}>
            {sections.map(section => (
                <ProductInformationItem
                    key={section.id}
                    title={section.title}
                    opened={openedSection[section.id]}
                    onToggle={() => toggleSection(section.id)}
                >
                    {section.content}
                </ProductInformationItem>
            ))}
        </div>
    );
}
